
class Account {

  static token_key = 'user_token'

  static setToken(token) {
    window.localStorage.setItem(Account.token_key, token);
  }

  static getToken() {
    const token = window.localStorage.getItem(Account.token_key);
    return token
  }

  static removeToken() {
    window.localStorage.setItem(Account.token_key,'')
  }


}

export {
  Account
}
